module.exports = __webpack_public_path__ + "img/personal-banner.e2f9481d.png";